// @flow
import goBack from 'fg-frontend/webActions/goBack';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import openModal from "./webActions/openModal";

export default (action) => {
	switch (action) {
		case 'goBack':
			return goBack;
		case 'toggleClass':
			return toggleClass;
		case 'openModal':
			return openModal;
		default:
			console.log(`Unknown action`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWebActions.js